import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Navigate } from "react-router-dom";
import { Card, Grid, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const fd = new FormData();

export default class AddNewTestimonial extends Component {
  state = {
    client_name: "",
    position: "",
    testimonial: "",
    client_image: null,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    this.setState({ loading: true });

    fd.append("name", this.state.client_name);
    fd.append("position", this.state.position);
    fd.append("content", this.state.testimonial);

    if (this.state.client_image instanceof File) {
      fd.append("client_image", this.state.client_image);
    }

    axios
      .post(Constants.postUrls.createTestimonial, fd)
      .then((resp) => {
        fd.delete("name");
        fd.delete("position");
        fd.delete("content");
        fd.delete("image");

        this.setState({
          notification: true,
          message: resp.data.message || "Testimonial added successfully",
          loading: false,
        });

        setTimeout(() => {
          this.setState({
            notification: false,
            message: "",
            redirect: true,
          });
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: err?.response?.data?.message || "Something went wrong",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 4000);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/testimonials" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Testimonial
              </MDTypography>
            </MDBox>

            {/* FORM */}
            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* NAME */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="client_name"
                      value={this.state.client_name}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>

                  {/* POSITION */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Position / Designation"
                      name="position"
                      value={this.state.position}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>

                  {/* IMAGE */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="file"
                      name="client_image"
                      label="Client Image"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ client_image: e.target.files[0] })
                      }
                    />
                  </Grid>

                  {/* TESTIMONIAL */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Testimonial"
                      name="testimonial"
                      value={this.state.testimonial}
                      onChange={this.handleInput}
                      required
                    />
                  </Grid>
                </Grid>

                <MDBox mt={2}>
                  <MDButton
                    variant="contained"
                    color="info"
                    type="submit"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Fabinov8 | Testimonial"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
